import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";

import NotFound from "./notfound";
import { Profile } from "../components/common";

const BASEURL = process.env.REACT_APP_BASEURL;

function getProfile(birds_id, email, setProfile, setErr, setIsLoading) {
    let url = `${BASEURL}/profile/${birds_id}`
    url = email ? `${url}?email=${email}` : url

    console.log(`url is ${url}`)
    axios
        .get(url)
        .then(res => {
            setProfile(res.data)
            setIsLoading(false)
        })
        .catch(err => {
            if (err.response?.status === 404) {
                setErr(true)
            }
        })
}

export default function ProfilePage () {
    const { birds_id } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const [profile, setProfile] = useState({})
    const [err, setErr] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const email = searchParams.get("email")

    console.log(`email is: ${email}`)

    useEffect(
        () => getProfile(birds_id, email, setProfile, setErr, setIsLoading),
        [birds_id, email]
    )

    if (err) {
        return (<NotFound />)
    } else {
        return isLoading ? (<></>) : (<Profile profile={profile} />)
    }
}